import Logo from '@/assets/logo.svg?react'
import { CONTAINER_MAX_WIDTH, NAV_BAR_HEIGHT } from '@/config/constants'
import { useAuth0 } from '@auth0/auth0-react'
import { Box, Button, Flex, HStack, Spacer } from '@chakra-ui/react'
import { useTranslation } from '@infraloop/i18n'
import { Link } from 'react-router'

/**
 * App bar for the signed-out pages. It carries the two actions a visitor needs — start the
 * Auth0 login, or open the registration form — and stands in for the dashboard's own app
 * bar, which can't render here because it shows the signed-in user's menu.
 */
const PublicAppBar = () => {
  // Hooks
  const { t } = useTranslation()
  const { loginWithRedirect } = useAuth0()

  return (
    <Box as="header" w="100%" flexShrink={0} bg="white" borderBottom="1px solid" borderColor="gray.200">
      <Flex align="center" w="100%" maxW={CONTAINER_MAX_WIDTH} mx="auto" px="28px" minH={`${NAV_BAR_HEIGHT}px`}>
        <Box asChild flexShrink={0}>
          <Link to="/" aria-label="Hatsuly" data-testid="public-nav-logo">
            <Logo height="25px" width="auto" title="Hatsuly" />
          </Link>
        </Box>

        <Spacer />

        <HStack gap="12px">
          <Button
            variant="ghost"
            onClick={() => {
              void loginWithRedirect()
            }}
            data-testid="public-nav-login"
          >
            {t('hatsuly.nav.login')}
          </Button>
          <Button colorPalette="blue" asChild data-testid="public-nav-register">
            <Link to="/register">{t('hatsuly.nav.register')}</Link>
          </Button>
        </HStack>
      </Flex>
    </Box>
  )
}

export default PublicAppBar
